import React from 'react';
import axios from 'axios';
import { handleJoinRequiresAbonement } from './abonementWizardEvents';
import {
  ActionButton,
  LoginButton,
  GamePlayers,
  KingOfTheHillPlayers,
  KingOfTheHillResults,
  KingOfTheHillPrePlayers,
  MorningOpenPlayers,
  MorningOpenPrePlayers,
  RandomRelationsPlayers,
  RandomRelationsResults,
  RandomRelationsPrePlayers,
  RandomRelationsMiniPlayers,
  TrainingQueue,
  GameDetailsInnerSummary,
  AlertInfo,
  AlertDanger,
  AlertPrepayment,
  AlertAfterReg,
  AlertTraining,
  NoActionButton,
  EmailPopupModal
} from './final.js';

class GameDetailsInnerRoot extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      game: this.props.game,
      showEmailPopup: false,
      email: this.props.game.email,
      emailError: '',
      isOfferAccepted: this.props.game.isofferaccepted
    };
  }

  componentDidMount() {
    // console.log(this.state.game);
  }

  handleClick = (e, action, friendSex = null) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (
      action.includes('join')
      && this.state.game.is_online_payment === "True"
      && !this.state.game.canRequestTrainingLevelApproval
    ) {
      if (this.state.isOfferAccepted == "False") {
        this.setState({ showEmailPopup: true, pendingFriendSex: friendSex });
      } else {
        this.createTicket(friendSex);
      }
    } else {
      this.handleJoin(action);
    }
  }

  handleEmailSubmit = (email) => {
    const { game, pendingFriendSex } = this.state;
    const data = new URLSearchParams();
    data.append('email', email);
    data.append('game_time_slot_id', game.id);

    axios.post('/api/update_email/', data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    .then(res => {
      if (res.data.success) {
        const userEmail = email;

        this.setState({ showEmailPopup: false, emailError: '', isOfferAccepted: true, pendingFriendSex: null }, () => {
          if (!this.state.email) {
            this.setState({ email: userEmail }, () => {
              this.createTicket(pendingFriendSex);
            });
          } else {
            this.createTicket(pendingFriendSex);
          }
        });
      } else {
        this.setState({ emailError: 'Ошибка при обновлении email' });
      }
    });
  }

  createTicket = (friendSex = null) => {
    const { game, email } = this.state;
    const data = new URLSearchParams();
    data.append('game_time_slot_id', game.id);
    data.append('email', email);
    if (friendSex) {
      data.append('friend_sex', friendSex);
    }

    axios.post('/payments/create_event/', data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    .then(res => {
      if (res.data.success) {
        window.location.href = res.data.payment_url;
      } else {
        console.error('Ошибка при создании платежа:', res.data.error);
      }
    })
    .catch(err => {
      console.error('Ошибка при создании платежа:', err);
    });
  }

  // Функция для определения операционной системы и источника
  getOsAndSource = () => {
    // Определяем операционную систему
    let operating_system = null;
    const userAgent = navigator.userAgent;
    if (/Android/i.test(userAgent)) {
      operating_system = 'android';
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
      operating_system = 'ios';
    } else if (/Mac OS/i.test(userAgent)) {
      operating_system = 'macos';
    } else if (/Windows/i.test(userAgent)) {
      operating_system = 'windows';
    } else if (/Linux/i.test(userAgent)) {
      operating_system = 'linux';
    }
    
    // Определяем источник
    let source = 'website';
    if (/Mobile/i.test(userAgent) && !/iPad/i.test(userAgent)) {
      source = 'mobile_web';
    }
    
    // Проверяем webview
    if (/wv|WebView/i.test(userAgent)) {
      source = 'webview';
    }
    
    // Проверяем telegram/vk
    if (window.location.href.includes('telegram')) {
      source = 'telegram';
    } else if (window.location.href.includes('vk.com')) {
      source = 'vk';
    }
    
    return { operating_system, source };
  }

  handleJoin = (action) => {
    // Добавляем параметры ОС и источника
    const { operating_system, source } = this.getOsAndSource();
    const separator = action.includes('?') ? '&' : '?';
    const actionWithParams = `${action}${separator}operating_system=${operating_system}&source=${source}`;
    
    axios.get(actionWithParams)
      .then(joinRes => {
        if (handleJoinRequiresAbonement(joinRes)) {
          return;
        }
        if (joinRes.data && joinRes.data.message_type === 'warning' && joinRes.data.message) {
          window.alert(joinRes.data.message);
          return;
        }
        if (joinRes.data && joinRes.data.message_type === 'info') {
          window.alert(joinRes.data.message);
        }
        axios.get('/api/games/' + this.state.game.id + '/' + this.state.game.name + '/')
          .then(res => {
            this.setState(prevState => {
              var game = Object.assign({}, prevState.game);
              game.totalPlayersNum = res.data._total_players_num;
              game.totalPlayersQueuedNumNum = res.data._total_players_queued_num;
              game.totalPlayersWithPaymentNum = res.data._total_players_with_payment_num;
              game.totalPlayersWithoutPaymentNum = res.data._total_players_without_players_num;
              game.isJoiningAvailable = res.data._is_joining_available;
              game.canJoinFriend = res.data._can_join_friend;
              game.canRequestTrainingLevelApproval = res.data._can_request_training_level_approval;
              game.isTrainingAdminJoiningAvailable = res.data._is_admin_joining_available;
              game.isUserJoined = res.data._is_user_joined;
              game.isUserFriendJoined = res.data._is_user_friend_joined;
              game.isUserPaid = res.data._is_user_paid;
              game.isSelfRegAvailable = res.data._is_self_reg_available;
              game.isSelfRegAvailableForPlayer = res.data._is_self_reg_available_for_player;
              game.players = res.data._players;
              game.playersQueued = res.data._players_queued;
              game.playersWithPayment = res.data._players_with_payment;
              game.playersWithoutPayment = res.data._players_without_payment;
              game.manPlayers = res.data._man_players;
              game.manPlayersWithPayment = res.data._man_players_with_payment;
              game.manPlayersWithoutPayment = res.data._man_players_without_payment;
              game.womanPlayers = res.data._woman_players;
              game.womanPlayersWithPayment = res.data._woman_players_with_payment;
              game.womanPlayersWithoutPayment = res.data._woman_players_without_payment;
              return { game };
            });
          });
      })
      .catch((error) => {
        const status = error && error.response && error.response.status;
        if (status === 403) {
          window.alert('Не удалось записаться. Перезайдите на сайт и попробуйте снова.');
          return;
        }
        window.alert('Не удалось записаться. Проверьте интернет и попробуйте снова.');
      });
  }

  handleLeave = (e, action) => {
    e.preventDefault();

    // Добавляем параметры ОС и источника
    const { operating_system, source } = this.getOsAndSource();
    const separator = action.includes('?') ? '&' : '?';
    const actionWithParams = `${action}${separator}operating_system=${operating_system}&source=${source}`;

    axios.get(actionWithParams)
      .then(res => {
        axios.get('/api/games/' + this.state.game.id + '/' + this.state.game.name + '/')
          .then(res => {
            this.setState(prevState => {
              var game = Object.assign({}, prevState.game);
              game.totalPlayersNum = res.data._total_players_num;
              game.totalPlayersQueuedNumNum = res.data._total_players_queued_num;
              game.totalPlayersWithPaymentNum = res.data._total_players_with_payment_num;
              game.totalPlayersWithoutPaymentNum = res.data._total_players_without_players_num;
              game.isJoiningAvailable = res.data._is_joining_available;
              game.canJoinFriend = res.data._can_join_friend;
              game.canRequestTrainingLevelApproval = res.data._can_request_training_level_approval;
              game.isTrainingAdminJoiningAvailable = res.data._is_admin_joining_available;
              game.isUserJoined = res.data._is_user_joined;
              game.isUserFriendJoined = res.data._is_user_friend_joined;
              game.isUserPaid = res.data._is_user_paid;
              game.isSelfRegAvailable = res.data._is_self_reg_available;
              game.isSelfRegAvailableForPlayer = res.data._is_self_reg_available_for_player;
              game.players = res.data._players;
              game.playersQueued = res.data._players_queued;
              game.playersWithPayment = res.data._players_with_payment;
              game.playersWithoutPayment = res.data._players_without_payment;
              game.manPlayers = res.data._man_players;
              game.manPlayersWithPayment = res.data._man_players_with_payment;
              game.manPlayersWithoutPayment = res.data._man_players_without_payment;
              game.womanPlayers = res.data._woman_players;
              game.womanPlayersWithPayment = res.data._woman_players_with_payment;
              game.womanPlayersWithoutPayment = res.data._woman_players_without_payment;
              return { game };
            });
          });
      });
  }

  paymentMessage = () => {
    if (this.state.game.isUserJoined && this.state.game.isTraining) {
      return (<div><AlertTraining /></div>);
    } else if (this.state.game.isUserJoined && (!this.state.game.isCompleted)
      && (this.state.game.isRandomRelations
        || this.state.game.isKingOfTheHill || this.state.game.isMorningOpen)) {
      if (!this.state.game.isUserPaid && this.state.game.isSelfRegAvailable && this.state.game.isSelfRegAvailableForPlayer) {
        return <AlertInfo />;
      } else if (!this.state.game.isUserPaid && this.state.game.isSelfRegAvailable && !this.state.game.isSelfRegAvailableForPlayer) {
        return <AlertPrepayment />;
      } else if (!this.state.game.isUserPaid && !this.state.game.isSelfRegAvailable) {
        return <AlertDanger />;
      } else if (!this.state.game.isRandomRelations) {
        return (
          <div>
            <div className="alert alert-info" role="alert">
              <a className="payment-info" rel="nofollow"
                href={"/pair_choice/?game_id=" + this.state.game.id}><b>Указать партнера</b></a>
              <br /><br />
              <a className="payment-info" rel="nofollow"
                href={"/self_replace/?game_id=" + this.state.game.id}><b>Замените себя</b></a>
            </div>
            <AlertAfterReg />
          </div>
        );
      } else if (this.state.game.isRandomRelations) {
        return (
          <div>
            <div className="alert alert-info" role="alert">
              <a className="payment-info" rel="nofollow"
                href={"/self_replace/?game_id=" + this.state.game.id}><b>Замените себя</b></a>
            </div>
            <AlertAfterReg />
          </div>
        );
      } else {
        return <AlertAfterReg />;
      }
    }
  }

  hasPrePlayers = () => {
    return (this.state.game.isRandomRelations || this.state.game.isKingOfTheHill || this.state.game.isMorningOpen) ? true : false;
  }

  hasQueue = () => {
    return (this.state.game.isTraining) ? true : false;
  }

  players = () => {
    if (this.state.game.isRandomRelations) {
      if (!this.state.game.isCompleted) {
        return <RandomRelationsPlayers game={this.state.game} />;
      } else {
        return <RandomRelationsResults game={this.state.game} flag="medals" />;
      }
    }
    if (this.state.game.isRandomRelationsMini) {
      return <RandomRelationsMiniPlayers game={this.state.game} />;
    }
    if (this.state.game.isKingOfTheHill) {
      if (!this.state.game.isCompleted) {
        return <KingOfTheHillPlayers game={this.state.game} />;
      } else {
        return <KingOfTheHillResults game={this.state.game} flag="medals" />;
      }
    }
    if (this.state.game.isMorningOpen) {
      return <MorningOpenPlayers game={this.state.game} />;
    }
    return <GamePlayers game={this.state.game} gameType={this.state.game.gameType} />;
  }

  prePlayersComponent = () => {
    if (this.state.game.isRandomRelations)
      if (!this.state.game.isCompleted) {
        return <RandomRelationsPrePlayers game={this.state.game} />;
      } else {
        return <RandomRelationsResults game={this.state.game} flag={"no medals"} />;
      }
    if (this.state.game.isKingOfTheHill)
      if (!this.state.game.isCompleted) {
        return <KingOfTheHillPrePlayers game={this.state.game} />;
      } else {
        return <KingOfTheHillResults game={this.state.game} flag={"no medals"} />;
      }
    if (this.state.game.isMorningOpen)
      return <MorningOpenPrePlayers game={this.state.game} />;
  }

  queueComponent = () => {
    if (this.state.game.isTraining)
      return <TrainingQueue game={this.state.game} />;
  }

  PrePlayersLabel = () => {
    if (this.state.game.isCompleted)
      return ""
    else
      return "Предварительная запись"
  }

  prePlayers = () => {
    if (this.hasPrePlayers())
      return (
        <div className="row">
          <div className="col-sm-12">
            <div className="game__title">{this.PrePlayersLabel()}</div>
            {this.prePlayersComponent()}
          </div>
        </div>
      )
    if (this.hasQueue())
      return (
        <div className="row">
          <div className="col-sm-12">
            <div className="game__title">Очередь</div>
            {this.queueComponent()}
          </div>
        </div>
      )
  }

  gameSummary = () => {
    return <GameDetailsInnerSummary game={this.state.game} addToCalendar={this.addToCalendar} />;
  }

  addActionButtons = () => {
    var result = [];

    if (!this.state.game.isCompleted && !this.state.game.isUser) {   // если турнир завершен, кнопки не отображаются
        result.push(<LoginButton key="login" />);
    }

    if (!this.state.game.isCompleted && this.state.game.isUser) {    // если турнир завершен, кнопки не отображаются
        // Все типы игр. Записаться или Оплатить участие
        if (!this.state.game.isUserJoined && this.state.game.isJoiningAvailable) {
            let buttonTitle = (
              this.state.game.is_online_payment === "True" && !this.state.game.canRequestTrainingLevelApproval
            ) ? 'Оплатить участие' : 'Записаться';
            result.push(
              <ActionButton
                handler={(e) => this.handleClick(e, '/api/games/'+ this.state.game.id +'/join/' + this.state.game.name + '/')}
                key="join" title={buttonTitle} colorStyle={'btn-primary'}
                gameType={this.state.game.gameType}
              />
            );
        }
        // Все типы игр. Нет записи
        if (!this.state.game.isUserJoined && !this.state.game.isJoiningAvailable) {
        result.push(<NoActionButton key="no-join" message={this.state.game.buttonMessage} />);
        }
        // COMPETITION. Подтвердить участие
        if (this.state.game.isUserJoined && this.state.game.eventType === 'COMPETITION' && !this.state.game.isUserPaid
            && this.state.game.isSelfRegAvailable && this.state.game.isSelfRegAvailableForPlayer) {
            result.push(
              <ActionButton
                handler={(e) => this.handleClick(e, '/api/games/'+ this.state.game.id +'/join/' + this.state.game.name + '/')}
                key="confirm" colorStyle={'btn-primary'}
                title={'Подтвердить участие'}
                gameType={this.state.game.gameType}
              />
            );
          }
        // TRAINING, GAME. Запись друга (М, Ж)
        if (this.state.game.isUserJoined && this.state.game.isJoiningAvailable && !this.state.game.isUserFriendJoined
            && this.state.game.canJoinFriend
            && (this.state.game.eventType === 'TRAINING' || this.state.game.eventType === 'GAME')) {
            result.push(
            <div key="join-friend-buttons" className="d-flex">
              <ActionButton
                handler={(e) => this.handleJoinFriend(e, 'M')}
                key="join-friend-male" colorStyle="btn-primary mr-2"
                title="Записать мальчика"
                gameType={this.state.game.gameType}
              />
              <ActionButton
                handler={(e) => this.handleJoinFriend(e, 'W')}
                key="join-friend-female" colorStyle="btn-pink"
                title="Записать девочку"
                gameType={this.state.game.gameType}
              />
            </div>
            );
        }
        // TRAINING, GAME. Отписать друга
        if (this.state.game.isUserFriendJoined) {
          result.push(
            <ActionButton
              handler={(e) => this.handleLeave(e, '/api/games/' + this.state.game.id + '/leave/' + this.state.game.name + '/friend/')}
              key="leave-other-friend"
              title={'Отписать друга'}
              colorStyle={'btn-danger'}
              gameType={this.state.game.gameType}
            />
          );
        }
        // Все типы игр. Отписаться
        if (this.state.game.isUserJoined && !this.state.game.isUserFriendJoined) {
            result.push(
              <ActionButton
                handler={(e) => this.handleLeave(e, '/api/games/' + this.state.game.id + '/leave/' + this.state.game.name + '/')}
                key="leave" colorStyle="btn-danger"
                title="Отписаться"
                gameType={this.state.game.gameType}
              />
            );
        }
        //          if (!this.state.game.isJoiningAvailable && this.state.game.eventType !== 'TRAINING') {
        //            result.push(
        //              <NoActionButton key="no-join-other" message={this.state.game.buttonMessage} />
        //            );
        //          }
    }


    return result;
  }

  handleJoinFriend = (e, friendSex) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    
    const action = `/api/games/${this.state.game.id}/join/${this.state.game.name}/friend/${friendSex}/`;
    this.handleClick(e, action, friendSex);
  }

  // Добавляет событие в календарь
  addToCalendar = () => {
    try {
      const { game } = this.state;
      
      // Отладочный вывод для проверки доступных полей
      console.log('Game object:', game);
      
      // Подготавливаем данные для календарного события
      const gameData = {
        title: game.title || game.socialTitle || 'Волейбол',
        description: game.description || game.socialDescription || '',
        startDateTime: game.startDateTime || game.start_datetime || game.startDatetime,
        duration: game.duration || 2,
        location: game.playingField || game.playing_field || 'Пляж',
        timeFrame: game.timeFrame || game.time_frame || '',
        price: game.price || '',
        coach: game.coachName || game.coach_name || game.coach || '',
        skill: game.gameSkillLevels || game.skill || '',
        isTraining: game.isTraining,
        isCompetition: game.isCompetition,
        isOutdoor: game.isOutdoor,
        eventType: game.eventType || game.event_type || 'GAME'
      };
      
      // Создаем календарное событие
      const icsContent = this.generateICSContent(gameData);
      
      // Скачиваем файл
      this.downloadICSFile(icsContent, gameData.title);
      
    } catch (error) {
      console.error('Ошибка при создании календарного события:', error);
      alert('Произошла ошибка при создании календарного события');
    }
  }

  // Генерирует содержимое .ics файла
  generateICSContent = (gameData) => {
    // Парсим дату и время начала
    let startDate = new Date(gameData.startDateTime);
    
    // Если дата некорректная, пробуем другие варианты
    if (isNaN(startDate.getTime())) {
      console.warn('Некорректная дата startDateTime:', gameData.startDateTime);
      console.warn('Попытка использовать текущую дату как fallback');
      startDate = new Date(); // Используем текущую дату как fallback
    }
    
    // Вычисляем дату окончания (добавляем продолжительность в часах)
    const endDate = new Date(startDate.getTime() + (gameData.duration * 60 * 60 * 1000));
    
    // Форматируем даты для .ics формата
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}${month}${day}T${hours}${minutes}${seconds}`;
    };
    
    const startFormatted = formatDate(startDate);
    const endFormatted = formatDate(endDate);
    const createdFormatted = formatDate(new Date());
    
    // Определяем тип события для заголовка
    let eventTypeLabel = 'Игра';
    if (gameData.isTraining) {
      eventTypeLabel = 'Тренировка';
    } else if (gameData.isCompetition) {
      eventTypeLabel = 'Турнир';
    }
    
    // Создаем заголовок события: "Пляж - тип события"
    const eventTitle = `Пляж - ${eventTypeLabel}`;
    
    // Создаем описание с подробной информацией и ссылкой
    let eventDescription = '';
    if (gameData.description) {
      eventDescription += `${gameData.description}\\n\\n`;
    }
    
    eventDescription += `Время: ${gameData.timeFrame}\\n`;
    eventDescription += `Тип: ${eventTypeLabel}\\n`;
    
    if (gameData.isOutdoor !== null) {
      eventDescription += `Локация: ${gameData.isOutdoor ? 'Улица' : 'Зал'}\\n`;
    }
    
    if (gameData.coach) {
      eventDescription += `Тренер: ${gameData.coach}\\n`;
    }
    
    if (gameData.skill) {
      eventDescription += `Уровень: ${gameData.skill}\\n`;
    }
    
    if (gameData.price) {
      eventDescription += `Стоимость: ${gameData.price}\\n`;
    }
    
    // Добавляем ссылку на событие
    const currentUrl = window.location.href;
    eventDescription += `\\n📱 Ссылка на событие: ${currentUrl}`;
    eventDescription += '\\n🌐 Сайт: https://play.bigbeach.ru';
    
    // Генерируем уникальный ID для события
    const eventId = `volleyball-${Date.now()}@bigbeach.ru`;
    
    // Создаем содержимое .ics файла
    const icsContent = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//BigBeach//Volleyball Calendar//RU',
      'CALSCALE:GREGORIAN',
      'METHOD:PUBLISH',
      'BEGIN:VEVENT',
      `UID:${eventId}`,
      `DTSTART:${startFormatted}`,
      `DTEND:${endFormatted}`,
      `DTSTAMP:${createdFormatted}`,
      `SUMMARY:${eventTitle}`,
      `DESCRIPTION:${eventDescription}`,
      `LOCATION:улица Фучика, 2, Санкт-Петербург (59.876003, 30.356903)`,
      'STATUS:CONFIRMED',
      'TRANSP:OPAQUE',
      'END:VEVENT',
      'END:VCALENDAR'
    ].join('\r\n');
    
    return icsContent;
  }

  // Добавляет событие в календарь (сразу открывает Google Calendar)
  downloadICSFile = (icsContent, eventTitle) => {
    // Сразу открываем Google Calendar для всех устройств
    this.openInGoogleCalendar();
  }

  // Определяет тип устройства и открывает соответствующий календарь
  openInGoogleCalendar = () => {
    try {
      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      
      if (isIOS) {
        // Для iOS открываем родной календарь
        this.openIOSCalendar();
      } else {
        // Для Android и всех остальных открываем Google Calendar
        this.openGoogleCalendar();
      }
      
    } catch (error) {
      console.error('Ошибка при открытии календаря:', error);
      this.showCalendarNotification('Ошибка при открытии календаря');
    }
  }

  // Открывает родной календарь iOS
  openIOSCalendar = () => {
    try {
      const { game } = this.state;
      
      // Подготавливаем данные для .ics файла
      const gameData = {
        title: game.title || game.socialTitle || 'Волейбол',
        description: game.description || game.socialDescription || '',
        startDateTime: game.startDateTime || game.start_datetime || game.startDatetime,
        duration: game.duration || 2,
        location: game.playingField || game.playing_field || 'Пляж',
        timeFrame: game.timeFrame || game.time_frame || '',
        price: game.price || '',
        coach: game.coachName || game.coach_name || game.coach || '',
        skill: game.gameSkillLevels || game.skill || '',
        isTraining: game.isTraining,
        isCompetition: game.isCompetition,
        isOutdoor: game.isOutdoor,
        eventType: game.eventType || game.event_type || 'GAME'
      };
      
      const startDate = new Date(gameData.startDateTime);
      if (isNaN(startDate.getTime())) {
        this.showCalendarNotification('Ошибка: некорректная дата события');
        return;
      }
      
      const endDate = new Date(startDate.getTime() + (gameData.duration * 60 * 60 * 1000));
      
      // Пробуем несколько способов открытия календаря iOS
      const success = this.tryIOSCalendarMethods(gameData, startDate, endDate);
      
      if (!success) {
        // Если ничего не сработало, fallback на Google Calendar
        console.log('iOS Calendar methods failed, falling back to Google Calendar');
        this.openGoogleCalendar();
      }
      
    } catch (error) {
      console.error('Ошибка при открытии календаря iOS:', error);
      // Fallback на Google Calendar
      this.openGoogleCalendar();
    }
  }

  // Пробует разные методы открытия календаря iOS
  tryIOSCalendarMethods = (gameData, startDate, endDate) => {
    // Метод 1: Правильный подход для iOS WebView с Blob
    try {
      const icsContent = this.generateICSContent(gameData);
      
      // Создаем Blob с правильным MIME-типом
      const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      
      // Создаем ссылку для скачивания
      const link = document.createElement('a');
      link.href = url;
      link.download = 'volleyball-event.ics';
      link.style.display = 'none';
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Освобождаем URL
      setTimeout(() => URL.revokeObjectURL(url), 100);
      
      this.showCalendarNotification('📅 Открываем Календарь iOS...');
      return true;
    } catch (error) {
      console.log('Blob download method failed:', error);
    }
    
    // Метод 2: Альтернативный подход для iOS - открытие в новом контексте
    try {
      const icsContent = this.generateICSContent(gameData);
      const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      // Не используем download атрибут для этого метода
      link.style.display = 'none';
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      
      this.showCalendarNotification('📅 Открываем Календарь iOS...');
      return true;
    } catch (error) {
      console.log('Target blank method failed:', error);
    }
    
    // Метод 3: Data URL fallback
    try {
      const icsContent = this.generateICSContent(gameData);
      const dataUrl = 'data:text/calendar;charset=utf-8,' + encodeURIComponent(icsContent);
      
      const link = document.createElement('a');
      link.href = dataUrl;
      link.target = '_blank';
      link.style.display = 'none';
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      this.showCalendarNotification('📅 Открываем Календарь iOS...');
      return true;
    } catch (error) {
      console.log('Data URL fallback failed:', error);
    }
    
    return false;
  }

  // Открывает Google Calendar
  openGoogleCalendar = () => {
    try {
      const { game } = this.state;
      
      // Подготавливаем данные
      const startDate = new Date(game.startDateTime || game.start_datetime);
      if (isNaN(startDate.getTime())) {
        this.showCalendarNotification('Ошибка: некорректная дата события');
        return;
      }
      
      const duration = game.duration || 2;
      const endDate = new Date(startDate.getTime() + (duration * 60 * 60 * 1000));
      
      const formatGoogleDate = (date) => {
        return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
      };
      
      const eventTypeLabel = game.isTraining ? 'Тренировка' : 
                            game.isCompetition ? 'Турнир' : 'Игра';
      
      // Заголовок: "Пляж - тип события"
      const title = `Пляж - ${eventTypeLabel}`;
      
      // Локация с координатами
      const location = `улица Фучика, 2, Санкт-Петербург (59.876003, 30.356903)`;
      
      // Создаем описание с ссылкой на событие
      let description = '';
      if (game.description) description += `${game.description}\n\n`;
      description += `Время: ${game.timeFrame || game.time_frame}\n`;
      description += `Тип: ${eventTypeLabel}\n`;
      
      if (game.isOutdoor !== null) {
        description += `Локация: ${game.isOutdoor ? 'Улица' : 'Зал'}\n`;
      }
      
      if (game.coach) description += `Тренер: ${game.coach}\n`;
      if (game.skill) description += `Уровень: ${game.skill}\n`;
      if (game.price) description += `Стоимость: ${game.price}\n`;
      
      // Добавляем ссылку на событие
      const currentUrl = window.location.href;
      description += `\n📱 Ссылка на событие: ${currentUrl}`;
      description += '\n🌐 Сайт: https://play.bigbeach.ru';
      
      const googleUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE` +
        `&text=${encodeURIComponent(title)}` +
        `&dates=${formatGoogleDate(startDate)}/${formatGoogleDate(endDate)}` +
        `&details=${encodeURIComponent(description)}` +
        `&location=${encodeURIComponent(location)}`;
      
      const newWindow = window.open(googleUrl, '_blank');
      
      if (newWindow) {
        this.showCalendarNotification('📅 Открываем Google Календарь...');
      } else {
        this.showCalendarNotification('❌ Не удалось открыть календарь. Проверьте блокировщик попапов.');
      }
      
    } catch (error) {
      console.error('Ошибка при открытии Google Calendar:', error);
      this.showCalendarNotification('Ошибка при открытии календаря');
    }
  }

  // Показывает уведомление о добавлении в календарь
  showCalendarNotification = (message) => {
    // Создаем элемент уведомления
    const notification = document.createElement('div');
    notification.textContent = message;
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background-color: #4CAF50;
      color: white;
      padding: 12px 20px;
      border-radius: 6px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      font-size: 14px;
      font-weight: 500;
      z-index: 10000;
      transform: translateX(100%);
      transition: transform 0.3s ease-out;
    `;
    
    // Добавляем в DOM
    document.body.appendChild(notification);
    
    // Анимируем появление
    setTimeout(() => {
      notification.style.transform = 'translateX(0)';
    }, 100);
    
    // Удаляем через 3 секунды
    setTimeout(() => {
      notification.style.transform = 'translateX(100%)';
      setTimeout(() => {
        if (notification.parentNode) {
          document.body.removeChild(notification);
        }
      }, 300);
    }, 3000);
  }

  render() {
    return (
      <React.Fragment>
        <div className="row">
          {this.gameSummary()}
          <div className="col-sm-6">
            {this.players()}
            {this.paymentMessage()}
            {this.addActionButtons()}
          </div>
        </div>
        {this.prePlayers()}
        <EmailPopupModal
          show={this.state.showEmailPopup}
          onClose={() => this.setState({ showEmailPopup: false })}
          onSubmit={this.handleEmailSubmit}
        >
        </EmailPopupModal>
      </React.Fragment>
    );
  }
}

export default GameDetailsInnerRoot;
